import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable, map } from 'rxjs';
import { ConstantsService } from 'src/app/services/constants.service';

@Injectable({
  providedIn: 'root'
})
export class CumpleIndicadorService {
  private url = ConstantsService.CUMPLE_INDICADORES_URL;
  private urlbulk = ConstantsService.CUMPLE_INDICADORES_BULK_URL

  private urlArchivos = ConstantsService.CUMPLE_INDICADORES_FILE_URL;
  constructor(private http: HttpClient) { }

  list(query = ''): Observable<any> {
    return this.http.get(`${this.url}${query}`).pipe(map(data => {
      return data;
    }));
  }

  create(formData: any): Observable<any> {
    return this.http.post(`${this.url}`, formData).pipe(map(data => {
      return data;
    }));
  }

  createBulk(formData: any): Observable<any> {
    return this.http.post(`${this.urlbulk}`, formData).pipe(map(data => {
      return data;
    }));
  }

  updateBulk(formData: any): Observable<any> {
    return this.http.patch(`${this.urlbulk}/0`, formData).pipe(map(
    data => {return data;
    }
  ));
}
  
  update(formData: any): Observable<any> {
    let { idSprCumpleIndicador } = formData;

    return this.http.patch(`${this.url}${idSprCumpleIndicador}`, formData).pipe(map(
      data => {
        return data;
      }
    ));
  }

  
  delete(dataDelete: any): Observable<any> {
    return this.http.patch(`${this.url}${dataDelete.idSprCumpleIndicador}`, dataDelete).pipe(map(data => {
      return data;
    }));

  }

  deleteBulk(formData: any): Observable<any> {
        return this.http.patch(`${this.urlbulk}/0`, formData).pipe(map(
        data => {return data;
        }
      ));
  }
  postArchivo(formData: any, id: number): Observable<any> {
    return this.http.post(`${this.urlArchivos}/` + id, formData).pipe(map(data => {
      return data;
    }));
  }

  download(name: string): Observable<any> {
    return this.http.get(`${this.urlArchivos}/` + name)
  }

}
